import React from 'react';
import injectSheet from 'react-jss';
import cn from 'classnames';
import PropTypes from 'prop-types';
import {
  buttonReset,
} from '../../styles/theme';

const PlayButton = ({ classes, className, onClick }) => (
  <button className={cn(classes.playButton, className)} type="button" onClick={onClick}>
    <svg width="90" height="90" viewBox="0 0 90 90">
      <path fill="currentColor" d="M69 44L29 64V24z" />
      <circle cx="45" cy="45" r="43" stroke="currentColor" fill="transparent" />
    </svg>
  </button>
);

PlayButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

PlayButton.defaultProps = {
  className: undefined,
  onClick: undefined,
};

export default injectSheet({
  playButton: {
    ...buttonReset(),
    cursor: 'pointer',
  },
})(PlayButton);
